import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { StoreProvider, createStore } from "easy-peasy";
import "./App.css";
import Profile from "./pages/Profile";
import SendMessage from "./pages/SendMessage";
import LIFFWindow from "./pages/LIFFWindow";
import ProfileNative from "./pages/ProfileNative";
import Pronore from "./pages/components/ProfileNoredi";
import Header from "./pages/components/Header";
import Login from "./pages/components/LoginAdmin";
import CircularIndeterminate from "./pages/components/nogroup";
import Regisadmin from "./pages/components/RegisAdmin";
import CreatGroup from "./pages/CreatGroup";
import CreatGroup_RPLC from "./pages/CreatGroup_RPLC";
import CreatGroup_Aicp from "./pages/CreatGroup_Aicp";
import RoutIndex from "./pages/components/RoutIndex";
import LineAdmin from "./pages/components/LineAdmin";
import LineRegis from "./pages/components/LineRegis";
import LineRegisPgh from "./pages/components/LineAdminpgh";
import Questions from "./pages/components/questions";
import Facebook from "./pages/components/facebook";
import Close from "./pages/test";
import Famin from "./pages/components/famin";
import Famout from "./pages/components/famout";
import CraamG from "./pages/components/LineAdmin_AAMG";
// import Questions from './pages/components/queslayout'

class App extends Component {
  render() {
    return (
      <div className="app">
        {/* <header className="app-header">
          <h3 className="app-title">React LIFF Boilerplate2</h3>
        </header> */}
        {/* <Header /> */}

        <Router>
          <div>
            <Route exact path="/" component={RoutIndex} />
            <Route exact path="/ProfileNative" component={ProfileNative} />
            <Route path="/profile" component={Profile} />
            <Route path="/message" component={SendMessage} />
            <Route path="/window" component={LIFFWindow} />
            <Route path="/pronore" component={Pronore} />
            <Route path="/login" component={Login} />
            <Route path="/regisadmin" component={Regisadmin} />
            <Route
              path="/CircularIndeterminate"
              component={CircularIndeterminate}
            />
            <Route path="/creatGroup" component={CreatGroup} />
            <Route path="/CreatGroup_RPLC" component={CreatGroup_RPLC} />
            <Route path="/CreatGroup_Aicp" component={CreatGroup_Aicp} />
            <Route path="/lineadmin" component={LineAdmin} />
            <Route path="/lineregis" component={LineRegis} />
            <Route path="/lineregispgh" component={LineRegisPgh} />
            <Route path="/questions" component={Questions} />
            <Route path="/facebook" component={Facebook} />
            <Route path="/Close" component={Close} />
            <Route path="/Famin" component={Famin} />
            <Route path="/Famout" component={Famout} />
            <Route path="/CraamG" component={CraamG} />
          </div>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// src/App.js